import { BigNumber, ethers } from 'ethers'
import { ISO_LANGUAGE_CODE_LOCALE } from 'locales/iso_language_codes'
import { CURRENCY_SHORT } from './money'
import { BNish } from 'utils'
import Big from 'big.js'

export const formattedDecimals = (amount: BNish, decimals: number): string => {
  const units = ethers.utils.formatUnits(amount === '' ? '0' : amount, decimals)

  return units
}

const currencyFormatOptions = {
  style: 'currency',
  minimumFractionDigits: 2,
  locale: 'en-US',
  currency: 'USD',
}

/**
 * HoC - Formats an amount based on locale and currency, defaults to US if this is not provided
 * // TODO: provide locale based on user settings
 * @exampe const usdFormat = currencyFormat("en-US", "USD"); usdFormat("89000");
 * @param locale The local language to format to @see ISO_LANGUAGE_CODE_LOCALE
 * @param currency The currency to format to @see CURRENCY_SHORT
 * @returns string formatted amount
 */
export const currencyFormat = (
  amount: Big | bigint | number | BigNumber | string,
  locale: ISO_LANGUAGE_CODE_LOCALE = 'en-US',
  currency: CURRENCY_SHORT = 'USD',
): string => {
  const options = { ...currencyFormatOptions, ...{ currency } }
  const formatter = new Intl.NumberFormat(locale, options)

  /**
   * Error boundary
   */
  //return a formatted zero amount if amount is falsey
  if (!amount) {
    return formatter.format(0)
  }

  /**
   * Normalise the amount
   */
  let formattedAmount
  if (amount instanceof Big || amount instanceof BigNumber) {
    formattedAmount = amount.toNumber()
  } else if (typeof amount === 'string') {
    formattedAmount = +amount
  } else {
    formattedAmount = amount
  }

  /**
   * Format
   */
  try {
    return formatter.format(formattedAmount)
  } catch {
    throw new Error(`Failed to format ${amount} into a currency`)
  }
}
